import { Button, FlexBox, Table } from '@dixa/lib-shared-habla';
import { LanguageContext } from 'lib-knowledge-management-common/contexts/language';
import { LanguageModel } from 'lib-knowledge-management-common/utils/language';
import { useModal } from 'lib-knowledge-modal';
import { useContext } from 'react';

import { LanguageRemoveModal } from '../modals/languageRemoveModal';
import styles from './enabledLanguagesForm.module.scss';

export function EnabledLanguagesForm(): JSX.Element {
  const { showModal } = useModal();
  const { enabledLanguages, defaultLanguage } = useContext(LanguageContext);
  function onRemoveLanguage(language: LanguageModel) {
    showModal(LanguageRemoveModal, {
      language,
    });
  }

  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Language</Table.Th>
          <Table.Th />
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {enabledLanguages.map((lang) => {
          const defaultLanguageId = defaultLanguage.languageId;
          const languageId = lang.languageId;
          const isDefaultLanguage = languageId === defaultLanguageId;
          const label = `${lang.description}${isDefaultLanguage ? ' (Default)' : ''}`;

          return (
            <Table.Tr key={languageId} className={styles.tableRow}>
              <Table.Td className={styles.tableCell}>{label}</Table.Td>
              {isDefaultLanguage ? (
                <Table.Td />
              ) : (
                <Table.Td>
                  <FlexBox justifyContent="flex-end">
                    <Button
                      variant="secondary"
                      onClick={() => onRemoveLanguage(lang)}
                    >
                      Remove
                    </Button>
                  </FlexBox>
                </Table.Td>
              )}
            </Table.Tr>
          );
        })}
      </Table.Tbody>
    </Table>
  );
}
